export const SESSION_FLAG_KEY = 'supplyco_has_session'

/**
 * One-shot handoff key set by /demoday's "Continue" button and consumed by
 * the dashboard. When present the dashboard mounts a brand-takeover overlay
 * over its first paint, then clears the key.
 *
 * Value shape: `{ "firstName": string, "ts": number }`. The dashboard
 * ignores the key entirely if `Date.now() - ts > DEMODAY_WELCOME_TTL_MS`,
 * so a stale flag from a forgotten tab doesn't trigger a fake "welcome"
 * the next time the user opens the app.
 */
export const DEMODAY_WELCOME_KEY = 'supplyco_demoday_welcome_v1'
export const DEMODAY_WELCOME_TTL_MS = 30_000

export const SUPPORT_EMAIL = 'support@supplyco.ai'

export const BOOK_CALL_URL
  = 'https://cal.com/team/supplyco/supplyco-demo?duration=30'

export const HELP_CENTER_URL = 'https://supplyco.support.site'
